// ─── Rich Presence (Electron uniquement) ─────────────────────────────────────
// Si l'utilisateur active la fonction dans ses paramètres, on diffuse à ses
// amis l'app qu'il a actuellement au premier plan (« joue à Skyrim », « est
// sur Firefox »…). C'est OPT-IN (off par défaut, sensible niveau vie privée).
//
// Respect du statut « invisible » : à la souche, le serveur filtre déjà la
// présence des invisibles (cf. utils/presence.js), donc l'activité ne sera pas
// diffusée pour eux. On ajoute aussi une garde côté client : si l'utilisateur
// passe en « invisible », on arrête tout de suite d'envoyer pour ne même pas
// stocker l'info côté serveur.
//
// Stockage de la préférence : localStorage (per-device), pas envoyé serveur.

import { socket } from './socket.js';

const STORAGE_KEY = 'chaos.richPresence.enabled';

export function getRichPresenceEnabled() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (_) { return false; }
}

function _statutCourant() {
    const badge = document.getElementById('self-status-badge');
    if (!badge) return null;
    for (const cls of badge.classList) {
        if (cls.startsWith('status-')) return cls.replace('status-', '');
    }
    return null;
}

function _envoyerActivite(payload) {
    if (_statutCourant() === 'invisible') {
        socket.emit('rich-presence-update', null);
        return;
    }
    socket.emit('rich-presence-update', payload);
}

export function setRichPresenceEnabled(enabled) {
    const bool = !!enabled;
    try { localStorage.setItem(STORAGE_KEY, bool ? '1' : '0'); } catch (_) {}
    if (window.chaosNative && typeof window.chaosNative.setRichPresence === 'function') {
        window.chaosNative.setRichPresence(bool);
    }
    if (!bool) {
        // Désactivation → on nettoie immédiatement côté serveur.
        socket.emit('rich-presence-update', null);
    }
}

function _setupUI() {
    // Sous Electron : montre la section, masque le hint « installe l'app bureau ».
    const section = document.getElementById('presence-section-electron');
    const hint = document.getElementById('presence-non-electron-hint');
    const checkbox = document.getElementById('toggle-rich-presence');
    if (section) section.style.display = '';
    if (hint) hint.style.display = 'none';
    if (checkbox) checkbox.checked = getRichPresenceEnabled();
}

export function initRichPresence() {
    if (!window.chaosNative || typeof window.chaosNative.onActiveApp !== 'function') {
        return; // hors Electron ou ancien build → section reste cachée, hint visible
    }
    // Setup UI (peut tourner avant que le DOM des params soit dans le DOM ;
    // on retente une fois à l'ouverture du panneau si nécessaire).
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _setupUI);
    } else {
        _setupUI();
    }
    // Démarre la détection si l'utilisateur l'avait laissée activée.
    if (getRichPresenceEnabled()) {
        window.chaosNative.setRichPresence(true);
    }
    window.chaosNative.onActiveApp((payload) => {
        if (!getRichPresenceEnabled()) return;
        _envoyerActivite(payload);
    });
}
